module.exports = __webpack_public_path__ + "assets/img/array2.56cb1828.svg";